interface StatusBadgeProps {
  isEnabled: boolean;
  activeText?: string;
  disabledText?: string;
}

export function StatusBadge({
  isEnabled,
  activeText = 'Active',
  disabledText = 'Disabled',
}: StatusBadgeProps) {
  if (isEnabled) {
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-confirm/20 text-brand-confirm">
        {activeText}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-warm/20 text-brand-warm">
      {disabledText}
    </span>
  );
}
